export const dogbreeds = [
  {
    id: "13",
    name: "Akita",
  },
  {
    id: "14",
    name: "Shiba Inu",
  },
  {
    id: "16",
    name: "Pitbull",
  },
  {
    id: "34",
    name: "Pug",
  },
  {
    id: "42",
    name: "Puggle",
  },
  {
    id: "51",
    name: "Australian Shepherd",
  },
  {
    id: "52",
    name: "Red Merle",
  },
  {
    id: "53",
    name: "Blue Merle",
  },
  {
    id: "57",
    name: "Papillon",
  },
  {
    id: "61",
    name: "Labrador",
  },
  {
    id: "62",
    name: "Husky",
  },
  /*     {
        "id": "63",
        "name": "Pomsky"
    }, */
  {
    id: "74",
    name: "Pomeranian",
  },
  {
    id: "83",
    name: "Siberian Husky",
  },
  {
    id: "85",
    name: "Jindo",
  },
  {
    id: "86",
    name: "Mastiff",
  },
  {
    id: "89",
    name: "Spinone Italiano",
  },
  {
    id: "90",
    name: "German Shepherd",
  },
  {
    id: "94",
    name: "Bulldog",
  },
  {
    id: "95",
    name: "Akbash",
  },
  {
    id: "96",
    name: "Maltipoo",
  },
  {
    id: "97",
    name: "Alaskan Malamute",
  },
  {
    id: "99",
    name: "Cocker Spaniel",
  },
  {
    id: "100",
    name: "Foxhound",
  },
  {
    id: "101",
    name: "Terrier",
  },
  {
    id: "102",
    name: "Aussiedoodle",
  },
  {
    id: "103",
    name: "Australian Labradoodle",
  },
  /*     {
        "id": "104",
        "name": "Labradoodle"
    }, */
  {
    id: "105",
    name: "Azawakh",
  },
  {
    id: "106",
    name: "Basenji",
  },
  {
    id: "107",
    name: "Beagle",
  },
  {
    id: "108",
    name: "Cheagle",
  },
  {
    id: "110",
    name: "Belgian Malinois",
  },
  {
    id: "111",
    name: "Bernedoodle",
  },
  {
    id: "112",
    name: "Bernese Mountain",
  },
  {
    id: "113",
    name: "Bichon Poodle",
  },
  {
    id: "114",
    name: "Blue Heeler",
  },
  {
    id: "115",
    name: "Boerboel",
  },
  {
    id: "116",
    name: "Border Collie",
  },
  {
    id: "117",
    name: "Border Terrier",
  },
  {
    id: "118",
    name: "Boston Terrier",
  },
  {
    id: "119",
    name: "Bouvier des Flandres",
  },
  {
    id: "120",
    name: "Boxer",
  },
  {
    id: "121",
    name: "Boykin Spaniel",
  },
  {
    id: "122",
    name: "Brindle Pitbull",
  },
  {
    id: "123",
    name: "Cairn Terrier",
  },
  /*   {
    id: "124",
    name: "Spaniel",
  }, */
  {
    id: "125",
    name: "Fox Terrier",
  },
  {
    id: "126",
    name: "Finnish Spitz",
  },
  {
    id: "127",
    name: "Spitz",
  },
  {
    id: "128",
    name: "Eurasier",
  },
  {
    id: "129",
    name: "Springer Spaniel",
  },
  {
    id: "130",
    name: "English Setter",
  },
  {
    id: "135",
    name: "Cane Corso",
  },
  {
    id: "136",
    name: "Cavachon",
  },
  {
    id: "137",
    name: "Cavalier King Charles Spaniel",
  },
  {
    id: "138",
    name: "Polish Greyhound",
  },
  {
    id: "139",
    name: "Maltese",
  },
  {
    id: "140",
    name: "Chihuahua",
  },
  {
    id: "141",
    name: "Chorkie",
  },
  {
    id: "142",
    name: "Chow Chow",
  },
  {
    id: "143",
    name: "Coonhound",
  },
  {
    id: "144",
    name: "Corgi",
  },
  {
    id: "145",
    name: "Doberman",
  },
  {
    id: "146",
    name: "Dogo Argentino",
  },
  {
    id: "147",
    name: "Dogo Sardo",
  },
  {
    id: "148",
    name: "Dogue de Bordeaux",
  },
  {
    id: "151",
    name: "Retriever",
  },
  {
    id: "152",
    name: "Poodle",
  },
  {
    id: "153",
    name: "Havapoo",
  },
  {
    id: "154",
    name: "Irish Setter",
  },
  {
    id: "155",
    name: "Jack Russell Terrier",
  },
  {
    id: "156",
    name: "Japanese Chin",
  },
  {
    id: "157",
    name: "Keeshond",
  },
  {
    id: "158",
    name: "Komondor",
  },
  {
    id: "159",
    name: "Kuvasz",
  },
  {
    id: "162",
    name: "Morkie",
  },
  {
    id: "163",
    name: "Newfoundland Dog",
  },
  {
    id: "164",
    name: "Nova Scotia Duck Tolling Retriever",
  },
  {
    id: "165",
    name: "Old English Sheepdog",
  },
  {
    id: "166",
    name: "Pomsky",
  },
  {
    id: "168",
    name: "Rottweiler",
  },
  {
    id: "169",
    name: "Saint Bernard",
  },
  {
    id: "170",
    name: "Saluki",
  },
  {
    id: "171",
    name: "Samoyed",
  },
  {
    id: "172",
    name: "Schipperke",
  },
  {
    id: "173",
    name: "Schnauzer",
  },
  {
    id: "174",
    name: "Scottish Terrier",
  },
  {
    id: "175",
    name: "Shar Pei",
  },
  {
    id: "176",
    name: "Sheepadoodle",
  },
  {
    id: "177",
    name: "Shih Tzu",
  },
  {
    id: "178",
    name: "Tosa",
  },
  {
    id: "179",
    name: "Toy Poodle",
  },
  {
    id: "180",
    name: "Vizla",
  },
  {
    id: "181",
    name: "Weimaraner",
  },
  {
    id: "182",
    name: "Wolf Dog",
  },
  {
    id: "0",
    name: "No Choice",
  },
];
